module.exports = __webpack_public_path__ + "assets/img/chase.66af2bb9.svg";